<template>
	<AuthLayout>
		<template #eyebrow>Email verification</template>
		<template #headline>Your email is<br/><span class="accent">verified.</span></template>
		<template #lead>You can now sign in to your account and start using the platform.</template>

		<div style="text-align:center;">
			<div class="auth-success-icon">
				<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
			</div>
			<h1 class="auth-card__title">Email Verified!</h1>
			<p class="auth-card__subtitle" style="margin-bottom:28px;">Your email has been successfully verified. You can now sign in.</p>
		</div>

		<router-link :to="{ name: 'v2-login' }" class="auth-btn" style="text-decoration:none;">
			Go to Sign In
			<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
		</router-link>
	</AuthLayout>
</template>


<script>
import AuthLayout from './auth-layout.vue';

export default {
	name: 'V2EmailVerified',

	components: {
		AuthLayout,
	},
};
</script>


<style lang="sass" scoped>
@import './auth-form-styles'

.auth-success-icon
	width: 64px
	height: 64px
	border-radius: 50%
	background: rgba($green, 0.15)
	color: $green
	display: flex
	align-items: center
	justify-content: center
	margin: 0 auto 16px
</style>
